import { useState, useEffect, useCallback, useMemo } from 'react';
import { ProductWithCalculations, CNPJGroup } from '../types/inventory';
import { fetchPedidoSugerido, fetchPedidoSugeridoGrouped } from '../../services/sellersApi';

export const useProducts = () => {
  const [products, setProducts] = useState<ProductWithCalculations[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadProducts = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await fetchPedidoSugerido();
      setProducts(data);
    } catch (err: any) {
      setError(err?.message || 'Erro ao carregar produtos');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadProducts();
  }, [loadProducts]);

  return { products, loading, error, refetch: loadProducts };
};

export const useProductsGrouped = () => {
  const [groups, setGroups] = useState<CNPJGroup[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadProducts = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await fetchPedidoSugeridoGrouped();
      setGroups(data);
    } catch (err: any) {
      setError(err?.message || 'Erro ao carregar produtos');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadProducts();
  }, [loadProducts]);

  const allProducts = useMemo(
    () => groups.flatMap((g) => g.products),
    [groups]
  );

  return { groups, allProducts, loading, error, refetch: loadProducts };
};
